import React from "react";
import sushiLogo from "../../images/front/sushi.svg";
import mocLogo from "../../images/front/MOC.svg";
import graphLogo from "../../images/front/graph.svg";
import alchemyLogo from "../../images/front/alchemy.svg";
import okuLogo from "../../images/front/oku.svg";
import sovrynLogo from "../../images/front/sovryn.svg";
import tropykusLogo from "../../images/front/tropykus.svg";
import woodswapLogo from "../../images/front/woodswap.svg";
import symbiosisLogo from "../../images/front/symbiosis.svg";
import rubicLogo from "../../images/front/rubic.svg";
import openoceanLogo from "../../images/front/openocean.svg";
import beefyLogo from "../../images/front/beefy.svg";
import jumperLogo from "../../images/front/jumper.svg";
import merklLogo from "../../images/front/merkl.svg";
import galxeLogo from "../../images/front/galxe.svg";
import collectiveLogo from "../../images/front/collective.svg";
import gelatoLogo from "../../images/front/gelato.svg";
import thirdwebLogo from "../../images/front/thirdweb2.svg";
import layerzeroLogo from "../../images/front/layerzero3.svg";
import stargateLogo from "../../images/front/stargate.svg";
import pellLogo from "../../images/front/pell.svg";
import uniswapLogo from '../../images/front/uniswap-white.svg';
import metamaskLogo from '../../images/front/metamask-hero.svg';

export const Clients = () => {
  return (
    <section className="pb-lg-16 pb-11 ">
      <div className="infinite-carousel-wrapper">
        <div className="itemRight item1">
          <img src={sushiLogo} alt="Sushi Logo" />
        </div>
        <div className="itemRight item2">
          <img src={mocLogo} alt="MOC Logo" />
        </div>
        <div className="itemRight item3">
          <img src={graphLogo} alt="Graph Logo" />
        </div>
        <div className="itemRight item4">
          <img src={okuLogo} alt="OKU Logo" />
        </div>
        <div className="itemRight item5">
          <img src={woodswapLogo} alt="WoodSwap Logo" />
        </div>
        <div className="itemRight item6">
          <img src={alchemyLogo} alt="Alchemy Logo" />
        </div>
        <div className="itemRight item7">
          <img src={symbiosisLogo} alt="Symbiosis Logo" />
        </div>
        <div className="itemRight item8">
          <img src={rubicLogo} alt="Rubic Logo" />
        </div>
      </div>
      <div className="infinite-carousel-wrapper">
        <div className="itemLeft item1">
          <img src={sovrynLogo} alt="Sovryn Logo" />
        </div>
        <div className="itemLeft item2">
          <img src={tropykusLogo} alt="Tropykus Logo" />
        </div>
        <div className="itemLeft item3">
          <img src={openoceanLogo} alt="OpenOcean Logo" />
        </div>
        <div className="itemLeft item4">
          <img src={beefyLogo} alt="Beefy Logo" />
        </div>
        <div className="itemLeft item5">
          <img src={jumperLogo} alt="Jumper Logo" />
        </div>
        <div className="itemLeft item6">
          <img src={merklLogo} alt="Merkl Logo" />
        </div>
        <div className="itemLeft item7">
          <img src={pellLogo} alt="Pell Logo" />
        </div>
        <div className="itemLeft item8">
          <img src={metamaskLogo} alt="Metamask Logo" />
        </div>
      </div>
      <div className="infinite-carousel-wrapper">
      <div className="itemRight item1">
          <img src={okuLogo} alt="OKU Logo" />
        </div>
        <div className="itemRight item2">
          <img src={uniswapLogo} alt="Uniswap Logo" />
        </div>
        <div className="itemRight item3">
          <img src={gelatoLogo} alt="Gelato Logo" />
        </div>
        <div className="itemRight item4">
          <img src={thirdwebLogo} alt="Thirdweb Logo" />
        </div>
        <div className="itemRight item5">
          <img src={layerzeroLogo} alt="LayerZero Logo" />
        </div>
        <div className="itemRight item6">
          <img src={stargateLogo} alt="Stargate Logo" />
        </div>
        <div className="itemRight item7">
          <img src={collectiveLogo} alt="Collective Logo" />
        </div>
        <div className="itemRight item8">
          <img src={galxeLogo} alt="Galxe Logo" />
        </div>
      </div>
    </section>
  );
};
